import React, {useState}  from "react";
import {
  Wrapper,
  Container,
  TitlesSection,
  SecondaryTitle,
  Title,
  GoodByeMessage,
  BackgroundImage,
  RSVPButton
} from "./endScreenStyles";
import { withRouter } from "react-router-dom";
// import EventCarousal from "../../components/EventCarousel";
import mainLogo from "../../assets/ademars/APxM_logo_Stacked-02.png";
import ReactGa from "react-ga";


function EndScreen({ setShowWrapUp, setShowWrapUpNov12, setShowWrapUpNov19 }) {

  const [activeButton,setActiveButton] = useState("wrapup")
  const [carouselIndex,setCarouselIndex] = useState(0)

  return (
      <Wrapper>
          <BackgroundImage>

          {/* <Overlay> */}
        <Container>
          <GoodByeMessage>
            <div>
              <SecondaryTitle>
                  Thank you
              </SecondaryTitle>
              <SecondaryTitle style={{fontFamily:'times-now-extra-light'}}>
                For Joining
              </SecondaryTitle>
            </div>
          </GoodByeMessage>
        </Container>
          <img draggable={false} src={mainLogo} className="main-logo" />
          </BackgroundImage>
      </Wrapper>
  );
}

export default withRouter(EndScreen);
